export default __webpack_public_path__ + "static/media/inspirasi-terkini3.a26b00b3.png";